module.exports = __webpack_public_path__ + "img/match_a.30d375c0.png";